module.exports = __webpack_public_path__ + "img/hamburger.35dd51be.svg";